import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import "./Testimonials.css";

import bannerImg from "../TestImages/TestStediBackground2.webp"; // swap to your banner image

function Testimonials() {
  return (
    <section className="testimonials-section pt-5">
      <Container fluid className="px-3 px-md-4 px-lg-5 pt-5">
        {/* TOP: Title + 3 columns */}
        <Row className="gy-4 align-items-start">
          <Col xs={12}>
            <h2 className="testimonials-title mb-2">
              Testimonials
            </h2>
          </Col>

          <Col xs={12} lg={4}>
            <div className="quote-box h-100">
              <p className="quote-text">
                Oh my goodness. Honestly I am speechless!
              </p>
              <p className="quote-text">
                The amount of time, effort, heart, thought, business acumen, planning, blood, sweat and tears
                that went into this app… whew I cannot imagine and I am so thankful!
              </p>
              <div className="quote-author mt-3">— LISA M</div>
            </div>
          </Col>

          <Col xs={12} lg={4}>
            <div className="quote-box h-100">
              <p className="quote-text">
                This is exactly what I needed for my team. I can definitely tell that it was designed by someone
                who has been in my shoes!
              </p>
              <div className="quote-author mt-3">— ANGIE S</div>
            </div>
          </Col>

          <Col xs={12} lg={4}>
            <div className="quote-box h-100">
              <p className="quote-text">
                I can literally delete at least 5 of the business/productivity apps I use on a daily basis because
                this combines every tool in one spot. THANK YOU!!
              </p>
              <div className="quote-author mt-3">— KARA G</div>
            </div>
          </Col>
        </Row>

        {/* IMAGE BANNER */}
        <div
          className="testimonial-banner mt-4"
          style={{ backgroundImage: `url(${bannerImg})` }}
        >
          <div className="testimonial-banner-overlay" />
        </div>

        {/* TAGLINE */}
        <div className="text-center mt-3">
          <div className="tagline">
            STREAMLINE YOUR DAY.<br />
            STRENGTHEN YOUR BUSINESS.
          </div>
        </div>
      </Container>
    </section>
  );
}

export default Testimonials;
